module.exports = __webpack_public_path__ + "static/img/logo_white_en.d967b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white_en.png
// module id = uD9h
// module chunks = 18